import { ComponentClass } from 'react';
export { ComponentClass };

import { UserVoiceNpsProps } from './components/UserVoiceNps';
import {
    UserVoiceFeedbackTags,
    TypeValues,
    Team1,
    UserVoiceFeedbackTxpTags,
    UserVoiceFeedbackSearchTags,
} from './services/UserVoiceFeedbackTags';
import { createLazyComponent, LazyModule, LazyAction, LazyImport } from 'owa-bundling';
import UserVoiceFeedbackType from 'owa-service/lib/contract/UserVoiceFeedbackType';
import { SuggestionDialogOptions } from './actions/showUserVoiceSuggestionDialog';

import { userVoiceSuggestionStore } from 'owa-uservoice/lib/store/store';
import { NpsLogDataPointProps } from './services/sendNpsLogDatapoint';

const lazyModule = new LazyModule(() => import(/* webpackChunkName: "UserVoice" */ './lazyIndex'));

export let lazyLaunchInAppFeedback = new LazyAction(lazyModule, m => m.launchInAppFeedback);
export let lazyShowUserVoiceSuggestionDialog = new LazyImport(
    lazyModule,
    m => m.showUserVoiceSuggestionDialog
);
export let UserVoiceNps = createLazyComponent(lazyModule, m => m.UserVoiceNps);
export { deactivateHelpCharmAction } from './actions/deactivateHelpCharmAction';
export {
    SuggestionDialogOptions,
    UserVoiceFeedbackType,
    UserVoiceFeedbackTags,
    UserVoiceNpsProps,
    TypeValues,
    Team1,
    UserVoiceFeedbackTxpTags,
    UserVoiceFeedbackSearchTags,
    userVoiceSuggestionStore,
    NpsLogDataPointProps,
};
